import * as React from "react";
import NextImage from "views/components/NextImage";
import { TBannerItem } from "../../../services/banner";
import { ViewMoreBox, RollOverContainer } from "./styles";
import { RollOverProps } from "./utils";
import { LinkTargetType } from "../../../services/playground";
import { transformAParam } from "utils/browser";
import { isNotBlankArray } from "utils/array";
import ViewMoreCard from "../ViewMoreCard";

class RollableCardBanner extends React.Component<RollOverProps> {
	render() {
		const {
			cardBanners,
			viewMore,
			positionId,
			placeholderBg,
			aTarget = LinkTargetType.Blank,
			isInApp,
			moduleIndex,
		} = this.props;
		if (!isNotBlankArray(cardBanners)) {
			return null;
		}
		const oneItem = cardBanners[0];
		const bannerHeight = oneItem.height
			? `calc(${oneItem.height} * 0.36 + 0.75rem)`
			: "auto";
		return (
			<RollOverContainer
				data-id={positionId}
				id={positionId}
				style={{
					minHeight: bannerHeight,
				}}
			>
				{(cardBanners || []).map((item: TBannerItem, index: number) => (
					<a
						{...transformAParam({
							isInApp: !!isInApp,
							aTarget,
							link: item.link,
						})}
						key={index}
					>
						<NextImage
							src={item.img}
							aliSize={2}
							qnParams={{ w: 135 }}
							isLazyLoad={false}
							online={this.props.online}
							placeholder={placeholderBg}
							fallbackSrc={placeholderBg}
							style={{ height: oneItem.height, width: oneItem.width }}
							moduleIndex={moduleIndex}
							moduleInnerIndex={index}
						/>
					</a>
				))}
				{viewMore?.link && (
					<ViewMoreCard
						StyledComponent={ViewMoreBox}
						link={viewMore.link}
						text={viewMore.text}
						isInApp={!!isInApp}
					/>
				)}
			</RollOverContainer>
		);
	}
}
export default RollableCardBanner;
